import React from 'react';
import navdata from "./LayoutMenuData";
import { NavLink } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import withRouter from 'Common/withRouter';

const TwoColumnLayout = (props: any) => {
    // For now, render a simple two-column menu using navdata
    const navData = (navdata() && navdata().props && navdata().props.children) ? navdata().props.children : [];
    return (
        <React.Fragment>
            <div id="two-column-menu">
                <ul className="navbar-nav">
                    {(navData || []).map((item: any, key: number) => (
                        <React.Fragment key={key}>
                            {item['isHeader'] ? (
                                <li className="menu-title">
                                    <span data-key="t-menu">{props.t ? props.t(item.label) : item.label}</span>
                                </li>
                            ) : (
                                <li className="nav-item">
                                    <NavLink
                                        to={item.link ? item.link : "/"}
                                        end
                                        className={({ isActive }) => isActive ? "nav-link menu-link active" : "nav-link menu-link"}
                                    >
                                        {item.icon && <i className={item.icon} style={{ marginRight: 8 }} />}
                                        <span className="menu-label">{props.t ? props.t(item.label) : item.label}</span>
                                    </NavLink>
                                </li>
                            )}
                        </React.Fragment>
                    ))}
                </ul>
            </div>
        </React.Fragment>
    );
};

export default withRouter(withTranslation()(TwoColumnLayout)); 